// js
import React from 'react';
import PropTypes from 'prop-types';
import SecurityDetailPPTX from '../../../containers/analytics/pptx/SecurityDetailPPTX';


const SecurityCriticalRudimentaryDetailPPTX = ({ data }) => {
  return (
    <SecurityDetailPPTX
      data={data}
      criticality='critical'
      adequacy='rudimentary'
    />
  );
};

SecurityCriticalRudimentaryDetailPPTX.propTypes = {
  data: PropTypes.object
};

export default SecurityCriticalRudimentaryDetailPPTX;



// WEBPACK FOOTER //
// ./src/components/analytics/pptx/SecurityCriticalRudimentaryDetailPPTX.js